import {Injectable} from '@angular/core';
import {OcapiService} from '../ocapi/ocapi.service';
import {Md5} from 'ts-md5/dist/md5';
import {LanguageService} from '../language/language.service';
import {DigitalData} from './digital-data';
import {AnalyticsOrder} from './analytics-order';
import {Order} from '../../model/order';

@Injectable()
export class AnalyticsService {

  udlObjectName = 'digitalData';

  constructor(private ocapiService: OcapiService, private languageService: LanguageService) {
    (<any>window).udlObjectName = this.udlObjectName;
  }

  public onHomePageWithProducts(omapiIds: Array<string>): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForHomePage(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
      omapiIds
    );
    this.track('page_loaded');
    this.track('user_data_loaded');
    this.track('products_loaded');
  }

  public onDetailPage(omapiIds: Array<string>): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForDetailPage(this.languageService.getCurrentLanguage(), Md5.hashStr(this.ocapiService.dtvIdentifier).toString(), omapiIds);
    this.track('page_loaded');
    this.track('user_data_loaded');
    this.track('products_loaded');
  }

  public onReadyToOrder(order: Order): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForOrderModal(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
      new AnalyticsOrder(order.packOmapiId, order.packPrice, order.subPackOmapiId, order.subPackPrice)
    );

    this.track('event_occurred');
  }

  public onProductOrdered(order: Order): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForPinEntered(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
      new AnalyticsOrder(order.packOmapiId, order.packPrice, order.subPackOmapiId, order.subPackPrice)
    );
    this.track('event_occurred');
  }

  public onOrderSucces(order: Order): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForOrderSuccess(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
      new AnalyticsOrder(order.packOmapiId, order.packPrice, order.subPackOmapiId, order.subPackPrice)
    );
    this.track('page_loaded');
    this.track('user_data_loaded');
    this.track('products_loaded');
  }

  public onVoucherCodeEntered(): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForVoucherEntered(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString()
    );
    this.track('event_occurred');
  }

  public onVoucherCodeResolved(omapiIds: string[]): void {
    (<any>window)[this.udlObjectName] = DigitalData.createForVoucherResolved(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
      omapiIds
    );
    this.track('event_occurred');
  }

  public onVoucherCodeFailed(): void {
    (<any>window)[this.udlObjectName] = DigitalData.createVoucherCodeFailed(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
    );
    this.track('event_occurred');
  }

  public onVoucherCodeSuccess(omapiId: string): void {
    (<any>window)[this.udlObjectName] = DigitalData.createVoucherCodeSuccess(
      this.languageService.getCurrentLanguage(),
      Md5.hashStr(this.ocapiService.dtvIdentifier).toString(),
      omapiId
    );
    this.track('event_occurred');
  }

  private track(trackName: string) {
    try {
      (<any>window)._satellite.track(trackName);
    } catch (e) {
      console.log('Error finding satellite track file for file[' + trackName + ']' + e);
    }
  }
}
